import { api } from './api-client';

const LOG_PREFIX = 'admin-ui:oauth-connect';

export interface OAuthConnectStartRequest {
    connection_name: string;
    app_key: string;
    integration_ref: string;
    auth_url: string;
    token_url: string;
    client_id?: string;
    client_secret?: string;
    scopes?: string;
    pkce?: boolean;
    registration_endpoint?: string;
    resource?: string;
    return_to?: string;
}

export async function startOAuthAuthorizationCode(req: OAuthConnectStartRequest): Promise<void> {
    const res = await api.post('/integrations/oauth-connect/start', req);
    const redirectUrl = (res.data as { redirect_url?: string } | undefined)?.redirect_url;
    if (!redirectUrl) {
        throw new Error('OAuth start did not return a redirect URL');
    }
    console.info(`${LOG_PREFIX}:start - redirecting to authorization server`);
    window.location.assign(redirectUrl);
}

export function oauthStrategyFromTypeConfig(tc: Record<string, unknown> | undefined): {
    authUrl: string;
    tokenUrl: string;
    scopes?: string;
    pkce: boolean;
    registrationEndpoint?: string;
    resource?: string;
} {
    const auth = tc?.auth as { strategies?: Record<string, Record<string, unknown>> } | undefined;
    const strat = auth?.strategies?.oauth2_authorization_code ?? {};
    const mcp = tc?.mcp as {
        server_url?: string;
        discovered_auth?: { registration_endpoint?: string };
    } | undefined;
    const scopesRaw = strat.scopes;
    const scopes = Array.isArray(scopesRaw)
        ? (scopesRaw as unknown[]).filter((s): s is string => typeof s === 'string').join(' ')
        : typeof scopesRaw === 'string'
            ? scopesRaw
            : undefined;
    return {
        authUrl: typeof strat.auth_url === 'string' ? strat.auth_url : '',
        tokenUrl: typeof strat.token_url === 'string' ? strat.token_url : '',
        scopes,
        pkce: strat.pkce !== false,
        registrationEndpoint: mcp?.discovered_auth?.registration_endpoint,
        resource: mcp?.server_url || (typeof tc?.base_url === 'string' ? tc.base_url : undefined),
    };
}
